import { getDepositLimits } from 'src_server/trpc/types/responsibleGambling';

type DepositLimitUsage = getDepositLimits.SuccessResponseType['limits'][number];

export const isMoreRestrictiveDepositLimitUsage = (
    candidate: DepositLimitUsage,
    current: DepositLimitUsage
): boolean => {
    const candidateRemaining = candidate.amount - candidate.used;
    const currentRemaining = current.amount - current.used;

    if (candidateRemaining < currentRemaining) {
        return true;
    }

    return candidateRemaining === currentRemaining && candidate.amount < current.amount;
};

export const getDepositLimitWindowLengths = (
    depositLimits: getDepositLimits.SuccessResponseType['limits']
): number[] => {
    const windows = new Set<number>();

    for (const limit of depositLimits) {
        windows.add(limit.windowLengthInDays);
    }

    return [...windows].sort((left, right) => left - right);
};

export const findMostRestrictiveDepositLimitUsage = (
    depositLimits: getDepositLimits.SuccessResponseType['limits'],
    windowLengthInDays: number
): DepositLimitUsage | undefined => {
    return depositLimits
        .filter((limitItem) => limitItem.windowLengthInDays === windowLengthInDays)
        .reduce<DepositLimitUsage | undefined>((mostRestrictive, candidate) => {
            if (mostRestrictive === undefined) {
                return candidate;
            }

            if (isMoreRestrictiveDepositLimitUsage(candidate, mostRestrictive)) {
                return candidate;
            }

            return mostRestrictive;
        }, undefined);
};
